import React from 'react';
import { Trash2, Edit, Plus, Eye } from 'lucide-react';

// Reusable DataSection Component
const DataSection = ({ title, data, columns, onEdit, onDelete, onAdd, onView, isLoading, emptyMessage }) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-medium text-gray-900">{title}</h2>
        <button 
          onClick={onAdd}
          className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700"
        >
          <Plus size={16} className="mr-1" /> Add New
        </button>
      </div>
      
      {isLoading ? (
        <div className="text-center py-4">Loading...</div>
      ) : (
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {columns.map(column => (
                    <th 
                      key={column.key} 
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {column.header}
                    </th>
                  ))}
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {data.length > 0 ? (
                  data.map((row) => (
                    <tr key={row.id}>
                      {columns.map(column => (
                        <td key={`${row.id}-${column.key}`} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {column.key === 'imagePreview' ? (
                            <div className="w-16 h-12 bg-gray-100 rounded overflow-hidden">
                              <img 
                                src={row.image_path ? (row.image_path.startsWith('http') ? row.image_path : `https://apissc.sainikschoolcadet.com/${row.image_path}`) : "/api/placeholder/64/48"} 
                                alt="Preview" 
                                className="w-full h-full object-cover" 
                                onError={(e) => {e.target.src = "/api/placeholder/64/48"}}
                              />
                            </div>
                          ) : column.key === 'activeStatus' ? (
                            <span className={`px-2 py-1 text-xs rounded-full ${row.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                              {row.active ? 'Active' : 'Inactive'}
                            </span>
                          ) : (
                            row[column.key]
                          )}
                        </td>
                      ))}
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <div className="flex justify-end items-center space-x-2">
                          {onView && (
                            <button 
                              onClick={() => onView(row.tag)} 
                              className="text-blue-600 hover:text-blue-900"
                              title="View Details"
                            >
                              <Eye size={18} />
                            </button>
                          )}
                          <button 
                            onClick={() => onEdit(row)} 
                            className="text-blue-600 hover:text-blue-900"
                            title="Edit"
                          >
                            <Edit size={18} />
                          </button>
                          <button 
                            onClick={() => onDelete(row.id)} 
                            className="text-red-600 hover:text-red-900"
                            title="Delete"
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length + 1} className="px-6 py-4 text-center text-sm text-gray-500">
                      {emptyMessage || "No items found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataSection;